import { Component, OnInit } from '@angular/core';
import { PlatformComponent } from '../../pages/platform/platform.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public platformName = '';
  constructor() {
  }

  ihealthTitile(){

    this.platformName = 'iHealthAge Platform';
    
  }
  ngOnInit(): void {
  }

}
